export default "__VITE_ASSET__CAa_BRCt__"